import React, { FunctionComponent } from 'react';

import Flex, { FlexProps } from '@gojob/ui-bits/Flex';

import { Breakpoint } from '@gojob/ui-bits/styles/theme';
import useTheme from '@gojob/ui-bits/styles/useTheme';

export interface BreakpointContainerProps extends FlexProps<'div'> {
  maxWidth?: Breakpoint;
}

const BreakpointContainer: FunctionComponent<BreakpointContainerProps> = (props) => {
  const { maxWidth, ...other } = props;
  const { breakpoint } = useTheme();

  return (
    <Flex
      width="100%"
      flexDirection="column"
      alignItems="stretch"
      maxWidth={maxWidth ? breakpoint.values[maxWidth] : undefined}
      {...other}
    />
  );
};

export default BreakpointContainer;
